<template>
	<textarea autocomplete="off" :id="element.attributes.id" :style="element.styles"
		:placeholder="element.attributes.placeholder"></textarea>
</template>

<script lang="ts">
import { Container } from "@/types/customPage";
import { defineComponent, PropType } from "vue";
import { doActionHelper } from "@/utils/action";

export default defineComponent({
	props: {
		element: {
			type: Object as PropType<Container>,
			required: true,
		},
	},
	methods: {
		doAction(container: Container) {
			doActionHelper(container);
		},
	},
});
</script>

<style scoped lang="scss"></style>
